<template lang="pug">
div
	i.movies-icon
	div.movies
		p(v-for="mov in thumbs") {{ mov.id }}
		div.movies-grid.columns.is-multiline.is-tablet
			div.column.is-half-tablet(v-for="movie in content.grid")
				figure
					a.movies-link(@click.stop="setOverlayer(movie)")
					img(v-if="movie.thumb != ''" v-bind:src="movie.thumb")
					iframe(v-else v-bind:src="'https://player.vimeo.com/video/'+movie.id+'/?title=0&byline=0&background=1&portrait=1&autoplay=0'" width="1600" height="1100" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen )
					.movies-details
						span
						i
						.movies-details-inner
							h4 {{movie.title}}
							p {{movie.copy}}
	div.movies-banderole
		a(v-bind:href="'https://vimeo.com/' + content.link_id" target="_blank") Mehr Filme auf Vimeo
</template>

<script>
import store from '@/store';

export default {
	name: 'Movies',
	props: ['content'],
	computed: {
		thumbs() {
			// store.commit('fetchVimeo', this.content.grid);
			// return store.state.vimeo;
		}
	},
	methods: {
		setOverlayer(item) {
			let iframe = `
				<div class="video-container">
					<h3>${item.title}</h3>
					<div class="video-frame">
						<iframe src="https://player.vimeo.com/video/${item.id}/?title=0&byline=0&autoplay=1"
							width="1600"
							height="900"
							frameborder="0"
							webkitallowfullscreen mozallowfullscreen allowfullscreen>
						</iframe>
					</div>
					<p>${item.details}</p>
				</div>`;
			store.commit('setOverlayerDom', iframe);
			this.$parent.$parent.openOverlayer();
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Movies/index.vue